import { useState, useMemo } from 'react';
import { useDateRange } from './useDateRange';

export function useDateRangeWrapper() {
  const [dateRange, setDateRange] = useState({
    from: null,
    to: null
  });

  const rangeUI = useDateRange(setDateRange);

  const presetDefs = useMemo(() => ([
    { key: 'all', text: 'All' },
    ...rangeUI.presetDefs
  ]), [rangeUI.presetDefs]);

  const setPreset = (key) => {
    if (key === 'all') {
      setDateRange({ from: null, to: null });
      rangeUI.setShowCustom(false);
      rangeUI.setPreset('24h'); // interno, no visible
      return;
    }

    rangeUI.setPreset(key);
  };

  return {
    dateRange,
    setDateRange,

    showCustom: rangeUI.showCustom,
    setShowCustom: rangeUI.setShowCustom,

    selectedLabel: rangeUI.selectedPreset === '24h' && dateRange.from === null ? 'All' : rangeUI.selectedLabel,
    selectedPreset: dateRange.from === null && dateRange.to === null ? 'all' : rangeUI.selectedPreset,

    setPreset,
    presetDefs
  };
}
